export const isFroalaInComposedPath = (path: EventTarget[]): boolean =>
  path.find((el) => {
    if (typeof (el as HTMLElement).className === "string") {
      return (el as HTMLElement).className.includes("froala-editor");
    }
    return false;
  }) != null;

export const unwrapElement = (el: Element) => {
  try {
    if (el && el.parentNode) {
      while (el.firstChild) {
        if (el.parentNode.contains(el))
          el.parentNode?.insertBefore(el.firstChild, el);
        else break;
      }
      el.remove();
    }
  } catch (e) {}
};

export const getFirstTextNode = (el: Node): Node | null => {
  if (!el) return null;
  if (el.nodeType === Node.TEXT_NODE) return el;

  for (let i = 0; i < el.childNodes.length; i++) {
    const child = el.childNodes[i];
    if (child.nodeType === Node.TEXT_NODE) {
      return child;
    } else {
      const textNode = getFirstTextNode(child);
      if (textNode !== null) return textNode;
    }
  }

  return null;
};

export const splitRanges = (range: Range) => {
  const ranges: Range[] = [];

  let el = range.startContainer;
  let elsToVisit = true;
  while (elsToVisit) {
    const startOffset = el == range.startContainer ? range.startOffset : 0;
    const endOffset =
      el == range.endContainer
        ? range.endOffset
        : range.startContainer.textContent!.length;

    const r = document.createRange();
    r.setStart(el, startOffset);
    r.setEnd(el, endOffset);
    ranges.push(r);

    elsToVisit = false;
    while (!elsToVisit && el != range.endContainer) {
      const nextEl = el.nextSibling && getFirstTextNode(el.nextSibling);
      if (nextEl) {
        el = nextEl;
        elsToVisit = true;
      } else {
        if (el.nextSibling) el = el.nextSibling;
        else if (el.parentNode) el = el.parentNode;
        else break;
      }
    }
  }

  return ranges;
};

export const getDeepestElementNode = (node: Element): Element => {
  if (
    node.nodeType === Node.ELEMENT_NODE &&
    !["EM-EMOJI", "I"].includes(node.tagName) &&
    node.hasChildNodes() &&
    node.lastElementChild != null
  ) {
    return getDeepestElementNode(node.lastElementChild);
  } else {
    return node;
  }
};
